import { PathPickMembershipStatus } from "@/features/types";

export interface PathPickMobileLink {
  key: string;
  pathname: string;
}

// 모바일에서 노출하는 패스픽 메뉴 — GNB 드로어(app-navigation)와 모바일 진입
// 화면(mobile-entry-page)이 같은 목록을 쓰도록 여기 모아 둔다.
// 한쪽만 고치면 두 화면이 어긋난다(같은 링크를 서로 다르게 보여준다).
//
// 키는 `common:` 접두사를 붙인 형태로 통일한다. i18n defaultNS가 common이라
// 접두사 유무와 무관하게 같은 값으로 풀리지만, GNB의 includeChildKeys는
// 메뉴 리터럴의 키와 문자열까지 같아야 매칭되므로 접두사 있는 쪽에 맞춘다.
export const PATHPICK_MOBILE_SECTION_KEY = "common:navigation.path_pick";

// 선언 순서가 곧 모바일 진입 화면의 노출 순서다. GNB는 메뉴 리터럴의 순서를
// 따르므로, 두 화면을 같은 순서로 보이게 하려면 여기도 리터럴과 같은 순서
// (상품 찾기 → 담은 상품 → 등록 신청 내역 → 주문 내역 → 멤버십)로 둬야 한다.
export const PATHPICK_MOBILE_LINKS: Record<
  | "searchProducts"
  | "basket"
  | "syncDownloadHistory"
  | "orderHistory"
  | "membership",
  PathPickMobileLink
> = {
  searchProducts: {
    key: "common:navigation.path_pick_search_products",
    pathname: "/pathpick/search-products",
  },
  basket: {
    key: "common:navigation.path_pick_basket",
    pathname: "/pathpick/basket",
  },
  syncDownloadHistory: {
    key: "common:navigation.path_pick_sync_download_history",
    pathname: "/pathpick/sync-download-history",
  },
  orderHistory: {
    key: "common:navigation.path_pick_order_history",
    pathname: "/pathpick/order-history",
  },
  membership: {
    key: "common:navigation.path_pick_membership",
    pathname: "/pathpick/membership",
  },
};

// GNB 화이트리스트가 남길 하위 메뉴 키.
// 실제로 무엇이 남는지는 메뉴 리터럴이 상태별로 만든 하위와의 교집합으로 정해진다 —
// 미가입(NONE)이면 리터럴 하위가 멤버십뿐이라 멤버십 한 줄만 남는다.
// 노출 순서는 리터럴의 원래 순서를 따르므로 이 배열의 순서는 영향이 없다.
export const PATHPICK_MOBILE_CHILD_KEYS: string[] = [
  PATHPICK_MOBILE_LINKS.searchProducts.key,
  PATHPICK_MOBILE_LINKS.basket.key,
  PATHPICK_MOBILE_LINKS.syncDownloadHistory.key,
  PATHPICK_MOBILE_LINKS.orderHistory.key,
  PATHPICK_MOBILE_LINKS.membership.key,
];

// 미가입(NONE)에게는 멤버십만 준다 — 나머지 패스픽 페이지는 PathPickAccessGuard가
// 같은 기준(BUYER + status !== "NONE")으로 막아, 링크를 줘도 접근 거부 화면만 본다.
// 멤버십 페이지는 그 가드 밖이라 미가입자도 열 수 있다(결제로 가는 통로).
// 만료(TRIAL_EXPIRED·SUBSCRIPTION_EXPIRED)는 가드를 통과하므로 전부 준다.
export function getPathPickMobileLinks(
  status: PathPickMembershipStatus
): PathPickMobileLink[] {
  return status === "NONE"
    ? [PATHPICK_MOBILE_LINKS.membership]
    : [
        PATHPICK_MOBILE_LINKS.searchProducts,
        PATHPICK_MOBILE_LINKS.basket,
        PATHPICK_MOBILE_LINKS.syncDownloadHistory,
        PATHPICK_MOBILE_LINKS.orderHistory,
        PATHPICK_MOBILE_LINKS.membership,
      ];
}
